import React from 'react';

import { useIsMobileView } from 'c-hooks';
import type { Props } from './Props';
import DesktopUserProfilePopOver from './DesktopUserProfilePopOver';
import MobileUserProfilePopOver from './MobileUserProfilePopOver';

const UserProfilePopOver = (props: Props) => {
    const isMobile = useIsMobileView();
    return (
        <>
            {props.userId && !isMobile && <DesktopUserProfilePopOver {...props} />}
            {props.userId && isMobile && <MobileUserProfilePopOver {...props} />}
        </>
    );
};

export default UserProfilePopOver;
